// Save migration for the rotary era (M2_SPEC §0): fills the M2 keys on wells, rigs and crew of older saves.
// Idempotent; JSON-safe defaults only.
import { eqDef, rigStats } from './defs.js';

export function migrateM2(s) {
  for (const r of Object.values(s.rigs ?? {})) {
    r.gear ??= { pump: null, collars: null, capping: null };
    r.bopUid ??= null;
    r.toolpusherId ??= null;
    r.auto ??= {};
    r.auto.program ??= null;
    r.auto.mudAuto ??= false;
    r.auto.optimize ??= true;
    r.auto.cement ??= true;
    r.auto.fish ??= true;
  }
  for (const w of Object.values(s.wells ?? {})) {
    const rig = w.rigId ? s.rigs?.[w.rigId] : null;
    w.rigType ??= rig ? rigStats(eqDef(rig.defId)).rigType : 'cable';
    w.rpm ??= 1.0;
    w.mud ??= { defId: null, ppg: 8.4 };
    w.string ??= null;
    w.bypassed ??= [];
    w.eLogged ??= false;
    w.cored ??= [];
    w.contract ??= null;
    w.strikeDay ??= null;
    w.strikeRigCond ??= null;
    w.kick ??= null;
    if (w.knownPore != null && typeof w.knownPore !== 'number') w.knownPore = null;
    w.knownPore ??= null;
    w.zonePore ??= {};
    w.annular ??= null;
    w.waterCut ??= 0;
    for (const c of w.casing ?? []) c.cemented ??= false;
  }
  for (const c of Object.values(s.crew ?? {})) if (c.role === 'toolpusher') c.pushes ??= [];
  const st = s.company?.stats;
  if (st) for (const k of ['bopSaves', 'kicks', 'blowouts', 'twistOffs', 'wasteBbl', 'wasteFines']) st[k] ??= 0;
  return s;
}
